
export default {
  steps: {
    instruction: 'Instrução',
    on: 'em',
    step: 'passo',
    gotoStep: 'Ir para passo'
  }
}
